module.exports = __webpack_public_path__ + "img/20_maska_kvadrat-ten.30b9daa.svg";